import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { t } from '../../../config/i18n';
import Tooltip from '../Tooltip';
import './Badge.scss';

const BadgeComponent = ({ badgeAction, tooltip }) => {
  const [badge, setBadge] = useState(0);

  useEffect(() => {
    async function caller() {
      const result = await badgeAction();
      setBadge(result);
    }
    if (badgeAction) {
      caller();
    }
  }, [badgeAction]);

  return (
    badge > 0 && (
      <>
        <span className="navbar-badge" data-tip data-for={tooltip}>
          {badge}
        </span>
        {tooltip && (
          <Tooltip id={tooltip} place="bottom">
            {t(tooltip)}
          </Tooltip>
        )}
      </>
    )
  );
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      badgeAction: ownProps.action,
    },
    dispatch
  );

const Badge = connect(null, mapDispatchToProps)(BadgeComponent);

export default Badge;
